import React from 'react'
import {
  EventRegistrationsQueryResult,
  EventRegistrationRole
} from 'graphql/generated'
import Link from 'next/link'
import Thumbnail from 'components/Thumbnail'
import LiveEventAttendeeListItemControls from './AttendeeListItemControls'
import RSVPListItemControls from './RSVPListItemControls'

export type IEventContext = 'event' | 'eventVideo'
interface IProps {
  attendee: EventRegistrationsQueryResult['event']['registrations']['edges'][0]['node']
  eventContext?: IEventContext
  children?: React.ReactNode
}

const EventAttendeeListItem: React.FC<IProps> = ({
  attendee,
  eventContext = 'eventVideo',
  children
}) => {
  return (
    <div>
      <Link target="_blank" href={`/profiles/${attendee.user.id}`}>
        <div className="flex space-x-2 p-3 hover:bg-gray-50 text-left rounded-lg">
          <div className="relative">
            <Thumbnail
              src={attendee.user.thumb}
              className={'h-12 w-12 rounded-full overflow-hidden shrink-0'}
            />
          </div>

          <div className="flex-1 space-y-1 flex items-center">
            <div>
              <p className="text-xs font-bold text-text-primary leading-tight">
                {attendee.user.displayName}
              </p>
            </div>
          </div>

          <div className="flex flex-row justify-end items-center space-x-1">
            {attendee.waitlisted && (
              <div className="bg-yellow-100 rounded-full py-1 px-2">
                <p className="text-xs font-light">Waitlisted</p>
              </div>
            )}
            {attendee.passive && (
              <div className="bg-yellow-100 rounded-full py-1 px-2">
                <p className="text-xs font-light">Viewing Only</p>
              </div>
            )}
            {attendee.role === EventRegistrationRole.HOST && (
              <div className="bg-yellow-100 rounded-full py-1 px-2">
                <p className="text-xs font-light">Event Host</p>
              </div>
            )}
            {attendee.role === EventRegistrationRole.SPEAKER && (
              <div className="bg-yellow-100 rounded-full py-1 px-2">
                <p className="text-xs font-light">Speaker</p>
              </div>
            )}
          </div>
        </div>
      </Link>

      <div>
        {eventContext === 'event' ? (
          <RSVPListItemControls attendee={attendee} />
        ) : (
          <LiveEventAttendeeListItemControls attendee={attendee} />
        )}
      </div>

      {children}
    </div>
  )
}

export default EventAttendeeListItem
